import React from 'react';

import { ThreeDimensionalCameraIcon } from '@paragon/material';

import { useAppMonitor } from '../../../monitor';
import { toggleLayout3DCamera } from '../../../store/actions/cameraActions';
import { isLayoutViewActive } from '../../../store/selectors/layoutModeSelectors';
import { getCurrentCameraType } from '../../../store/slices/camera/selectors';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export function Layout3DCameraButton(props: { visibleLabel?: boolean }) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const camera = useAppSelector(getCurrentCameraType);
  const layoutViewActive = useAppSelector(isLayoutViewActive);

  if (!layoutViewActive) return null;

  return (
    <ToolbarIconButton
      title="3D Camera"
      clickableDuringPicking
      visibleLabel={props.visibleLabel}
      sx={{ whiteSpace: 'nowrap' }}
      icon={<ThreeDimensionalCameraIcon sx={{ marginRight: 1 }} />}
      toggleValue={camera === 'perspective-layout'}
      onClick={() => {
        monitor.recordInteraction('3D Camera button clicked', {
          actionType: camera === 'perspective-layout' ? '2d' : '3d',
        });
        dispatch(toggleLayout3DCamera());
      }}
    />
  );
}
